"use client"
import { Card, CardMedia, CardContent, Typography, Box, Container } from "@mui/material"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import Footer from "../components/Footer"

import roomCardImg from "../assets/images/villas-suites-bubble.jpg"
import wellnessCenterImg from "../assets/images/wellnesscenter.jpg"
import pbPavilionImg from "../assets/images/pbpavilionbar.jpg"

const INTER_FONT = "'Inter', Arial, Helvetica, sans-serif"

export default function Home() {
  const cards = [
    { img: roomCardImg, label: "Reserve a Suite & Villa", to: "/rooms" },
    { img: wellnessCenterImg, label: "Reserve Wellness Center", to: "/wellness" },
    { img: pbPavilionImg, label: "Reserve PB Pavilion", to: "/pbpavilion" },
  ]

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        overflowX: "hidden",
        fontFamily: INTER_FONT,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Background video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          minWidth: "100%",
          minHeight: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src="/videos/sunsetbluedark.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Content */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingY: 6,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 4,
            zIndex: 1,
          }}
        >
          {cards.map((item, index) => (
            <Link to={item.to} key={index} style={{ textDecoration: "none" }}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Card
                  sx={{
                    width: { xs: 280, sm: 300, md: 330 },
                    position: "relative",
                    fontFamily: INTER_FONT,
                    color: "white",
                    overflow: "hidden",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: "-100%",
                      width: "100%",
                      height: "100%",
                      background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)",
                      transition: "left 0.6s ease-in-out",
                      zIndex: 2,
                      pointerEvents: "none",
                    },
                    "&:hover::before": {
                      left: "100%",
                    },
                    "&:hover": {
                      boxShadow: "0 0 30px rgba(255, 255, 255, 0.3)",
                    },
                  }}
                >
                  <CardMedia component="img" image={item.img} height="300" sx={{ filter: "brightness(0.7)" }} />
                  <CardContent
                    sx={{
                      position: "absolute",
                      bottom: 16,
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      sx={{
                        fontFamily: INTER_FONT,
                        fontWeight: 600,
                        letterSpacing: 0.2,
                        color: "white",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Link>
          ))}
        </Box>
      </Container>

      {/* Footer */}
      <Footer />
    </Box>
  )
}
